import { COUNTRY_CONFIGRATION } from 'const';

const calculateTax = (amount, countryCode) => {
  const taxRate = COUNTRY_CONFIGRATION[countryCode]?.tax;
  return amount * taxRate;
};

export const calculatePayableAmount = (amount, country) => {
  const tax = calculateTax(amount, country);
  return {
    tax,
    payable: amount + tax,
  };
};

export const SubscriptionHelper = {
  calculateTax,
  calculatePayableAmount,
};
